import React from 'react';
import { connect } from 'react-redux';

import * as Types from 'types';
import { requestArtStreamListForQuery, getArtStreamListId } from 'features/vault-artworks/actions';
import { getList } from 'features/lists/selectors';

import { PlaylistContainer } from 'playlists/PlaylistContainer';
import { createListToPlaylistSelector } from 'features/playlists/selectors';
import { ArtStreamArtworksFilterContainer } from './ArtStreamArtworksFilterContainer';
import { ContentTip } from './ContentTip';

type StateProps = {
  artStreamList: Types.List<Types.Artwork>;
  artStreamPlaylist: Types.Playlist;
  filterQuery: string;
  isFetching: boolean;
};

type DispatchProps = {
  requestArtStreamListForQuery: (query: string) => void;
};

type OwnProps = Types.Styleable;

type Props = StateProps & DispatchProps & OwnProps;

export class ArtStreamArtworksSelector extends React.Component<Props> {
  componentDidMount() {
    // Fetch only if list is not yet populated
    if (this.props.artStreamList.initial) {
      this.props.requestArtStreamListForQuery(this.props.filterQuery);
    }
  }

  componentDidUpdate(prevProps: Props) {
    const hasFilterChanged = this.props.filterQuery !== prevProps.filterQuery;
    if (hasFilterChanged) {
      this.props.requestArtStreamListForQuery(this.props.filterQuery);
    }
  }

  render() {
    const { isFetching, artStreamPlaylist, artStreamList } = this.props;
    const isFetchingForTheFirstTime = isFetching && artStreamList.initial;

    return (
      <div className='artworks-selector'>
        <p className='vault-tip-text mb-1'>
          You can add any artwork available on Sedition that is not sold out. Search by artist name
          or artwork title, or choose from suggested artworks.
        </p>
        <ArtStreamArtworksFilterContainer className='mb-1' />
        <ContentTip
          filter={this.props.filterQuery}
          isFetching={isFetching}
          resultCount={artStreamPlaylist.items.length}
        />
        {!isFetchingForTheFirstTime && (
          <PlaylistContainer
            items={artStreamPlaylist.items}
            droppable={false}
            playlistIsEditable={false}
            isEdit
            showFilter
            showAdd
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: Types.RootState) => {
  const listId = getArtStreamListId(state.playlists.artStreamArtworksFilter);
  const artStreamList = getList(state, {
    listId,
    byId: state.artworks.byId,
  });
  const playlistSelector = createListToPlaylistSelector(listId);
  const artStreamPlaylist = playlistSelector(state);

  return {
    filterQuery: state.playlists.artStreamArtworksFilter,
    isFetching: state.playlists.artStreamArtworksFetching,
    artStreamPlaylist,
    artStreamList,
  };
};

const mapDispatchToProps = {
  requestArtStreamListForQuery,
};

export const ArtStreamArtworksSelectorContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ArtStreamArtworksSelector);
